module.exports = __webpack_public_path__ + "media/overlays/06-21612b9d.png";